import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";

import FirmParameterTableFilter from "../Filters/FirmParameterTableFilter";
import FirmParameterAddForm from "../Forms/FirmParameterAddForm";
import FirmParameterUpdateForm from "../Forms/FirmParameterUpdateForm";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";

const FirmParameter = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(
      `/FirmParameter?$count=true${filter}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/FirmParameter/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/FirmParameter/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const columns = [
    {
      title: "Cari Kodu",
      dataIndex: "firmCode",
    },
    {
      title: "Cari Ünvanı",
      dataIndex: "firmName",
    },
    {
      title: "Komisyon Yüzdesi",
      dataIndex: "posCollectionCommissionRate",
      align: "right",
      width: 150,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Ödeme Seti",
      render: (row) => row.paymentSetName ?? "Varsayılan",
    },
    {
      title: "Düzenle",
      align: "center",
      render: (row) => (
        <a onClick={() => handleOnClickUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <Row align="middle">
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginBottom: 0 }}>
            <BarsOutlined /> CARİ TANIMLARI
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Cari Tanımı Ekle
          </Button>
        </Col>
      </Row>

      <FirmParameterTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addFirmParameterDrawer"
        title="Cari Tanımı Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <FirmParameterAddForm onSuccess={onAddSuccess} />
      </Drawer>

      <Drawer
        id="updateFirmParameterDrawer"
        title="Cari Tanımı Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <FirmParameterUpdateForm
          data={updateFormData}
          onSuccess={onUpdateSuccess}
        />
      </Drawer>
    </>
  );
};

export default FirmParameter;
